<template>
  <div class="droit-choice">
    <div v-if="isUser">
      <!-- Si l'utilisateur a des droits -->
      <div v-if="isDroits">
        <h1 class="mb-5">
          <span v-if="loading"> Bienvenue sur OREOL </span>
          <span v-else> Sélectionnez votre profil </span>
        </h1>

        <!-- Alerte -->
        <b-alert :model-value="true" class="rounded" variant="info" show v-if="loading">
          <b-spinner small label="Small Spinner"></b-spinner>
          <span class="ms-2"> Chargement des profils utilisateurs... </span>
        </b-alert>
        <!--Droit Card-->
        <div class="row" v-else>
          <div
            v-for="(profile, index) in profiles"
            :key="profile.index"
            class="col-12 col-sm-4 profile-card__container"
          >
            <div @click="setSelectedDroit(profile.droits)">
              <profile-card :class="` profile-card--${index}`">
                <template #header>
                  <div
                    class="icon-big"
                    :class="`icon-${getIconType(profile.libelle)}`"
                  >
                    <i :class="getIconClass(profile.libelle)"></i>
                  </div>
                </template>
                <template #content>
                  <div class="d-flex flex-column justify-content-center numbers">
                    <div>
                      <p class="profile-card__label">
                        <span v-if="isAdministrateurPortail(profile.libelle)">
                          Administration centrale
                        </span>
                        <span v-else-if="isAdministrateur(profile.libelle)">
                          DREAL, DRIEAT ou DEAL
                        </span>
                        <span v-else-if="isGestionnaire(profile.libelle)">
                        DREAL, DRIEAT, DEAL ou UD
                        </span>
                        <span v-else-if="isExploitant(profile.libelle)">
                          Exploitant
                        </span>
                      </p>
                      <p class="profile-card__label">
                        <span v-if="isAdministrateurPortail(profile.libelle)">
                          {{profile.nomRegion}} (DGPR)
                        </span>
                        <span v-else-if="isAdministrateur(profile.libelle)">
                          {{ $filters.formatDepartement(profile.nomRegion) }}
                        </span>
                        <span v-else-if="isGestionnaire(profile.libelle)">
                          {{ profile.nomServiceDreal }}
                        </span>
                      </p>
                    </div>
                  </div>
                </template>
              </profile-card>
            </div>
          </div>
        </div>
      </div>

      <!-- Si l'utilisateur n'a pas de de droits -->
      <div v-else>
        <h1 class="mb-4">Informations de compte incomplètes</h1>
        <!-- Alertes -->
        <b-alert :model-value="true" class="rounded" variant="danger" show>
          <i class="ti-alert me-2"></i>
          Vos droits n'ont pas encore été attribués, veuillez contacter un
          administrateur du site.
        </b-alert>
      </div>
    </div>
    <div v-else>
      <h1 class="mb-5">Erreur de connexion</h1>
      <!-- Alerte -->
      <b-alert :model-value="loading" class="rounded mt-3" variant="danger" show>
        <i class="ti-alert me-2"></i>
        La connexion au serveur a échouée, vous pouvez réactualiser la page ou
        essayer de vous reconnecter.
      </b-alert>
    </div>
  </div>
</template>
<script>
import { collectiviteService } from "@/service/collectivite.service.js";
import { parcService } from "@/service/parc.service.js";
import { lexiqueService } from "@/service/lexique.service.js";
import { ProfileCard } from "@/components/index";
import { mapGetters } from "vuex";
import {BAlert, BSpinner} from "bootstrap-vue-next";

export default {
  components: {
    ProfileCard,
    BAlert,
    BSpinner
  },
  data() {
    return {
      profiles: [],
      loadingProfiles: true,
      loadingService: null,
      loadingRegion: null
    };
  },
  computed: {
    ...mapGetters({
      isUser: "isUser",
      droits: "droits",
      isDroits: "isDroits",
      isRegions: "isRegions",
      nomRegionByInseeRegion: "nomRegionByInseeRegion",
      nomEquipeByEquieId: "nomEquipeByEquieId",
      homePageRouteObject: "homePageRouteObject"
    }),
    loading() {
      return !(
        !this.loadingService &&
        !this.loadingRegion &&
        !this.loadingProfiles
      );
    }
  },
  watch: {
    loading() {
      if (!this.loading && this.profiles.length === 1) {
        const firstProfile = this.profiles[0];
        if (firstProfile && firstProfile.droits) {
          this.$store.dispatch("saveSelectedDroit", firstProfile.droits);
          this.$router.push(this.homePageRouteObject).catch(() => {});
        } else {
          console.error("Aucun profil valide trouvé.");
        }
      }
    }
  },
  created() {
    this.$store.dispatch("resetSearchParams");
    if (this.droits) {
      this.setProfiles().then(() => {
        if (this.droits.length === 1 && this.profiles.length === 1) {
          const firstProfile = this.profiles[0];
          if (firstProfile && firstProfile.droits) {
            this.$store.dispatch("saveSelectedDroit", firstProfile.droits);
            this.$router.push(this.homePageRouteObject).catch(() => {});
          }
        }
      });
    }
  },
  methods: {
    async setProfiles() {
      this.loadingProfiles = true;
      this.profiles = [];

      //Parcours des droits du SSO
      for (const droit of this.droits) {
        // Sélection de OREOL
        const profil = {
          libelle: droit.profil,
          nomRegion: "",
          nomServiceDreal: "",
          droits: droit
        };

        if (droit.profil === "Exploitant" && !this.profiles.some((p) => p.libelle === droit.profil)) {
          this.profiles.push(profil);
        } else if (droit.profil === "Gestionnaire") {
          try {
            const data = await lexiqueService.getLexEquipeDrealById(droit.code_entite);
            if (data) {
              profil.nomServiceDreal = data.libelle;
            }
          } catch (err) {
            console.error("Erreur lors de la récupération de l'équipe DREAL :", err);
          }
          this.profiles.push(profil);
        } else if (droit.profil === "Administrateur") {
          if (!this.isRegions) {
            try {
              await this.getRegions();
            } catch (err) {
              console.error("Erreur lors de la récupération des régions :", err);
            }
          }
          profil.nomRegion = this.nomRegionByInseeRegion(droit.region);
          this.profiles.push(profil);
        } else if (droit.profil === "Administrateur portail") {
          this.profiles.unshift(profil);
        }
      }

      this.loadingProfiles = false;
    },
    setSelectedDroit(droit) {
      this.$store.dispatch("saveSelectedDroit", droit);
      this.$router.push(this.homePageRouteObject);
    },
    getRegions() {
      return new Promise((resolve, reject) => {
        collectiviteService
          .getRegions()
          .then(data => {
            this.$store.dispatch("saveRegions", data);
          })
          .then(() => {
            resolve();
          })
          .catch(err => {
            console.log(err);
            reject(err);
          });
      });
    },
    getIconClass(droitRole) {
      switch (droitRole) {
        case "Administrateur portail":
          return "ti-world";
        case "Administrateur":
          return "ti-map";
        case "Gestionnaire":
          return "ti-server";
        default:
          return "ti-flag-alt-2";
      }
    },
    getIconType(droitRole) {
      switch (droitRole) {
        case "Administrateur portail":
          return "success";
        case "Administrateur":
          return "info";
        case "Gestionnaire":
          return "warning";
        default:
          return "info";
      }
    },
    isAdministrateurPortail(droitRole) {
      return droitRole === "Administrateur portail";
    },
    isAdministrateur(droitRole) {
      return droitRole === "Administrateur";
    },
    isGestionnaire(droitRole) {
      return droitRole === "Gestionnaire";
    },
    isExploitant(droitRole) {
      return droitRole === "Exploitant";
    }
  }
};
</script>
<style lang="scss">
.droit-choice {
  .profile-card {
    .icon-big {
      position: relative;

      i {
        position: absolute;
        font-size: 45px;
        top: 6px;
        left: 12px;
      }
    }

    &__container {
      min-width: 405px;
      max-width: 420px;
    }
    &__name {
      font-size: 0.7em;
    }
    @media screen and (max-width: 405px) {
      .icon-big {
        i {
          font-size: 30px;
          top: 4px;
          left: 6px;
        }
      }
      &__container {
        min-width: unset;
      }
    }
  }
}
</style>
